document.addEventListener("DOMContentLoaded", () => {
  let lastScrollTop = 0; // Store the last scroll position
  let isMobile = window.innerWidth < 768;

  const header = document.querySelector("header");
  const mobileMenuBtn = document.getElementById("mobile-menu-btn");
  const navContainer = document.querySelector(".nav-container");
  const parentLinkBtns = header.querySelectorAll('.parent-link-btn');
  const childLinkBtns = header.querySelectorAll('.child-link-btn');
 

  const toggleMobileMenu = () => {
    const isActive = navContainer.classList.contains("mobile-menu-active");
    if (isActive) {
      navContainer.classList.remove("mobile-menu-active");
      mobileMenuBtn.classList.remove("rotate-plus");
      enableScroll();
    } else {
      navContainer.classList.add("mobile-menu-active");
      mobileMenuBtn.classList.add("rotate-plus");
      disableScroll();
    }
  };

  const onScroll = () => {
    isMobile = window.innerWidth < 768;
    if (!isMobile) {
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > 64) {
        if (scrollTop > lastScrollTop) {
          // SCROLLING DOWN
          header.classList.add("hide-nav-container");
        } else if (scrollTop < lastScrollTop) {
          // SCROLLING UP
          header.classList.remove("hide-nav-container");
        }
      } else {
        header.classList.remove("hide-nav-container");
      }

      lastScrollTop = scrollTop <= 0 ? 0 : scrollTop; // Prevent negative values
    }
  };

  mobileMenuBtn.addEventListener("click", toggleMobileMenu);

  const activateChildNav = (parentBtn, childNav) => {
    if (!parentBtn || !childNav) return;
    parentBtn.classList.add('parent-btn-active');
    parentBtn.setAttribute('aria-expanded', true);

    childNav.setAttribute('aria-hidden', false);
    childNav.classList.add('active');
  }

  const deActivateChildNav = (parentBtn, childNav) => {
    if (!parentBtn || !childNav) return;
    parentBtn.classList.remove('parent-btn-active');
    parentBtn.setAttribute('aria-expanded', false);

    childNav.setAttribute('aria-hidden', true);
    childNav.classList.remove('active');
  }

  const activeGrandChildNav = (parentBtn, childNav) => {
    if (!parentBtn || !childNav) return;
    parentBtn.classList.add('parent-btn-active');
    parentBtn.setAttribute('aria-expanded', true);

    childNav.setAttribute('aria-hidden', false);
    childNav.classList.add('active');
  }

  const deActivateGrandChildNav = (parentBtn, childNav) => {
    if (!parentBtn || !childNav) return;
    parentBtn.classList.remove('parent-btn-active');
    parentBtn.setAttribute('aria-expanded', false);

    childNav.setAttribute('aria-hidden', true);
    childNav.classList.remove('active');
  }

  const onParentBtnClick = (event) => {
    const index = event.target.dataset.index;
    if (index !== undefined) {
      let childNav = document.querySelector(`[data-parent="${index}"]`)
      if (childNav) {
        childNav.classList.contains('active') ? deActivateChildNav(event.target, childNav) : activateChildNav(event.target, childNav);
      }
    }
  }

  const onChildBtnClick = event => {
     const index = event.target.dataset.index;
     if (index !== undefined) {
      let grandchildNav = document.querySelector(`[data-child="${index}"]`)
      if (grandchildNav) {
        grandchildNav.classList.contains('active') ? deActivateGrandChildNav(event.target, grandchildNav) : activeGrandChildNav(event.target, grandchildNav);
      }
     }
  }

  if (parentLinkBtns?.length) {
    for (let parentLinkBtn of parentLinkBtns) {
      parentLinkBtn.addEventListener('click', onParentBtnClick);
    }
  }

  if (childLinkBtns?.length) {
    for (let childLinkBtn of childLinkBtns) {
      childLinkBtn.addEventListener('click', onChildBtnClick);
    }
  }
  

  window.addEventListener("scroll", onScroll);
});
